import LoadingButton from "@mui/lab/LoadingButton";
import { required, TextInput, useRefresh } from "react-admin";
import { getAuthenticatedBackendClient } from "../api/backend.api.js";
import { reportError } from "../backoffice.utils.js";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { FormProvider, useForm } from "react-hook-form";
import { Invoice as InvoiceDto, UserAddress } from "../generated/backendClient";
import { useDialog } from "../hooks/useDialog.js";

export function UpdateAddressOnPDFButton({ invoice }: { invoice: InvoiceDto }) {
  const refresh = useRefresh();
  const { openDialog, dialogProps } = useDialog();
  const formProps = useForm<UserAddress>({
    mode: "onChange",
    defaultValues: {
      name: invoice.recipient_address?.name || "",
      company: invoice.recipient_address?.company || "",
      street: invoice.recipient_address?.street || "",
      street2: invoice.recipient_address?.street2 || "",
      zipcode: invoice.recipient_address?.zipcode || "",
      city: invoice.recipient_address?.city || "",
      country: "DE",
    },
  });
  const closeDialog = () => {
    // prevent closing the dialog when the action is still running
    if (formProps.formState.isSubmitting) return;
    dialogProps.onClose();
  };
  const updateAddressOnPDF = async (userAddress: UserAddress) => {
    try {
      const backendClient = await getAuthenticatedBackendClient();
      showSuccessToast(`Das PDF wird neu generiert...`);
      await backendClient.invoice.invoiceUpdateAddressOnPdfCreate({ id: invoice.id, requestBody: userAddress });
      showSuccessToast(`Fertig. Bitte überprüfe manuell noch einmal ob das PDF nun korrekt ist.`);
      refresh();
    } catch (error) {
      reportError(`Error when regenerating invoice PDF ${invoice.id}`, error);
      showErrorToast(`Das Rechnungs PDF konnte nicht neu generiert werden.`);
    } finally {
      dialogProps.onClose();
    }
  };

  return (
    <>
      <Button variant="contained" size="small" onClick={openDialog}>
        Bearbeiten
      </Button>
      <Dialog {...dialogProps} onClose={closeDialog}>
        <DialogTitle>Rechnungsaddresse ändern</DialogTitle>
        <DialogCloseButton onClick={closeDialog} disabled={formProps.formState.isSubmitting} />
        <DialogContent>
          <FormProvider {...formProps}>
            <form>
              <Stack style={{ marginTop: "10px" }}>
                <TextInput
                  disabled={formProps.formState.isSubmitting}
                  source="name"
                  label="Name"
                  validate={required()}
                />
                <TextInput disabled={formProps.formState.isSubmitting} source="company" label="Firma" />
                <TextInput
                  disabled={formProps.formState.isSubmitting}
                  source="street"
                  label="Straße"
                  validate={required()}
                />
                <TextInput disabled={formProps.formState.isSubmitting} source="street2" label="Straße 2" />
                <TextInput
                  disabled={formProps.formState.isSubmitting}
                  source="city"
                  label="Ort"
                  validate={required()}
                />
                <TextInput
                  disabled={formProps.formState.isSubmitting}
                  source="zipcode"
                  label="PLZ"
                  validate={required()}
                />
                {/*<TextInput source="country" />*/}
              </Stack>
            </form>
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            variant="contained"
            onClick={formProps.handleSubmit(updateAddressOnPDF)}
            loading={formProps.formState.isSubmitting}
            disabled={formProps.formState.isSubmitting}
          >
            Speichern
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
